import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import css from './index.module.scss';
import { submitWholeHome, submitDailyUse } from './service';
import { useGlobal } from '@/utils/useGlobal';

export default function Footer({ calcObj, callback }: any) {
    const { useLang, useRouter, useState, useEffect, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');

    const {
        apps,
        extend = [],
        selected,
        selectedText = '',
        step,
        check1,
        totalPower = 0,
        totalWatt = 0,
        peakCharges = '',
        offpeakCharges = '',
        bill = '',
        checkB = 1,
        dpuNum = 0,
        ebNum = 0,
        remove = false,
        totalDiscount = 0,
        totalOriginal = 0,
        link_buy = '',
        products,
    } = calcObj;

    const handleToStep2 = () => {
        callback({ ...calcObj, step: 2 });
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator1_solar_generator',
            step: check1 === 2 ? t('header_step1_b') : t('header_step1'),
            product_name: t(`step1_text${check1}`),
            option_name: t(`step1_text${check1}`),
            button_name: t('footer_next'),
        });
    };

    const handleToStep3 = () => {
        const dpuNum =
            check1 === 1
                ? calcObj?.selected?.includes('ac_150A')
                    ? 2
                    : totalWatt <= 0
                    ? 0
                    : totalWatt <= 7200
                    ? 1
                    : totalWatt <= 14400
                    ? 2
                    : 3
                : check1 === 2
                ? checkB
                : 0;
        const EB_MAX = dpuNum * 4;
        const ebNum = Math.min(Math.floor((totalPower / 1000 - 6 * (dpuNum - 1)) / 6), EB_MAX);
        callback({
            ...calcObj,
            step: 3,
            dpuNum,
            ebNum,
        });

        if (check1 === 1) {
            const tempApps = [];
            apps?.map((group: any) => {
                tempApps?.push(group?.apps);
            });
            const flatApps = tempApps.flat();

            let strs = '';
            selected?.map((item: string, k: number) => {
                flatApps?.map((list: any) => {
                    if (list?.key === item) {
                        strs += (k === 0 ? '' : '_') + list?.title;
                    }
                });
            });
            gtm.push({
                event: 'uaEvent',
                event_name: 'calculator2_solar_generator',
                step: t('header_step2'),
                product_name: t(`step1_text1`),
                option_name: strs,
                button_name: t('footer_result'),
            });
        }
        if (check1 === 2) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'calculator3_solar_generator',
                step: t('header_step2_b'),
                product_name: t('step1_text2'),
                button_name: t('footer_result'),
                consumption: calcObj?.energy + t('step2_B_kwh_mon'),
                price: t('step2_B_currency') + calcObj?.bill,
                charge1: calcObj?.peakCharges,
                charge2: calcObj?.offpeakCharges,
                option_name1: `${t(`step2_B_select${calcObj?.checkB}_title`)} ${t(`step2_B_select${calcObj?.checkB}_power`)}`,
            });
        }
    };

    const handleBackToStep1 = () => {
        callback({ step: 1, check1: calcObj.check1, selected: [], apps: [], totalPower: 0, totalWatt: 0 });

        if (check1 === 1) {
            const tempApps = [];
            apps?.map((group: any) => {
                tempApps?.push(group?.apps);
            });
            const flatApps = tempApps.flat();

            let strs = '';
            selected?.map((item: string, k: number) => {
                flatApps?.map((list: any) => {
                    if (list?.key === item) {
                        strs += (k === 0 ? '' : '_') + list?.title;
                    }
                });
            });
            gtm.push({
                event: 'uaEvent',
                event_name: 'calculator2_solar_generator',
                step: t('header_step2'),
                product_name: t(`step1_text1`),
                option_name: strs,
                button_name: t('footer_back'),
            });
        }

        if (check1 === 2) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'calculator3_solar_generator',
                step: t('header_step2_b'),
                product_name: t('step1_text2'),
                button_name: t('footer_back'),
                consumption: Number(calcObj?.energy) + t('step2_B_kwh_mon'),
                price: t('step2_B_currency') + Number(calcObj?.bill),
                charge1: calcObj?.peakCharges,
                charge2: calcObj?.offpeakCharges,
                option_name1: `${t(`step2_B_select${calcObj?.checkB}_title`)} ${t(`step2_B_select${calcObj?.checkB}_power`)}`,
            });
        }
    };

    const handleSubmit = async () => {
        let solutionText = '';
        solutionText += dpuNum > 0 ? t('step3_dpu') + (dpuNum === 1 ? '' : ` x ${dpuNum}`) : '';
        solutionText += remove ? '' : (solutionText ? ', ' : '') + t('step3_shp2');
        solutionText += ebNum > 0 ? `, ${t('step3_eb') + (ebNum === 1 ? '' : ` x ${ebNum}`)}` : '';
        let extendText = '';
        extend?.map((exd: any) => {
            if (exd?.quantity > 0) {
                if (extendText) {
                    extendText += ', ';
                }
                extendText += exd.title;
                if (exd?.quantity > 1) {
                    extendText += ` x ${exd.quantity}`;
                }
            }
        });
        if (check1 === 1) {
            const custom = apps[apps.length - 1].apps[0].key;
            const hasNoCustom = custom === 'customize';
            const data = {
                application: selectedText,
                customName: hasNoCustom ? '--' : custom.title,
                customRating: hasNoCustom ? '--' : custom.watt,
                customTime: hasNoCustom ? '--' : custom.hours,
                power: totalWatt,
                energy: Math.round((totalPower * 100) / 1000) / 100,
                solution: solutionText,
                extend: extendText,
            };
            try {
                const res = await submitWholeHome(data, locale);
                if (res?.code !== '0') {
                    console.error(res?.message);
                }
            } catch (e) {
                console.error(e);
            } finally {
                return true;
            }
        }
        if (check1 === 2) {
            const data = {
                bill,
                peakCharges,
                offPeakCharges: offpeakCharges,
                energy: Math.round((100 * (totalPower * 30)) / 1000) / 100,
                selection: checkB === 1 ? '< 7.2' : checkB === 2 ? '7.2-14.4' : checkB === 3 ? '14.4-21.6' : '--',
                solution: solutionText,
                extend: extendText,
            };
            try {
                const res = await submitDailyUse(data, locale);
                if (res?.code !== '0') {
                    console.error(res?.message);
                }
            } catch (e) {
                console.error(e);
            } finally {
                return true;
            }
        }
        return true;
    };

    return (
        <div className={`dpu-calculator-footer ${css['dpu-calculator-footer']}`}>
            {step === 1 && (
                <button className={`next ${!check1 ? 'disabled' : ''}`} disabled={!check1} onClick={handleToStep2}>
                    {t('footer_next')}
                </button>
            )}
            {step === 2 && (
                <div className="btns">
                    {locale !== 'ca' && (
                        <button className="back" onClick={handleBackToStep1}>
                            {t('footer_back')}
                        </button>
                    )}
                    <button
                        className={`result ${
                            (check1 === 1 && totalPower === 0) || (check1 === 2 && (!peakCharges || !offpeakCharges || !bill || !totalPower)) ? 'disabled' : ''
                        }`}
                        onClick={handleToStep3}
                    >
                        {t('footer_result')}
                    </button>
                </div>
            )}
            {step === 3 && (
                <div className="footers-box">
                    <div className="sum-box">
                        <div className="price-box">
                            <span className="total-discount">{FormatMoneyLocal(totalDiscount, locale)}</span>
                            {totalDiscount !== totalOriginal && <span className="total-original">{FormatMoneyLocal(totalOriginal, locale)}</span>}
                        </div>
                        <div className="installation">
                            <svg className="affirm" xmlns="http://www.w3.org/2000/svg" width="37" height="16" viewBox="0 0 37 16" fill="none">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.98743 13.7707C2.5385 13.7707 2.30797 13.5487 2.30797 13.1835C2.30797 12.504 3.0663 12.2759 4.44828 12.1291C4.44828 13.0342 3.83555 13.7695 2.98379 13.7695L2.98743 13.7707ZM3.58196 8.67841C2.59432 8.67841 1.45864 9.14311 0.842274 9.63451L1.40526 10.8236C1.90029 10.371 2.69866 9.98395 3.41938 9.98395C4.10612 9.98395 4.48468 10.2133 4.48468 10.6755C4.48468 10.9849 4.23352 11.1427 3.76032 11.2046C1.98887 11.4339 0.599609 11.9228 0.599609 13.2878C0.599609 14.3701 1.37007 15.0241 2.57369 15.0241C3.43272 15.0241 4.19712 14.5473 4.56112 13.92V14.8542H6.16271V10.94C6.16271 9.32633 5.04281 8.67477 3.58318 8.67477L3.58196 8.67841ZM19.6585 8.85434V14.8482H21.373V11.9605C21.373 10.5882 22.2029 10.1841 22.7816 10.1841C23.0425 10.1817 23.2973 10.2569 23.5145 10.4013L23.8287 8.81673C23.5858 8.71959 23.3258 8.67255 23.0643 8.67841C22.1835 8.67841 21.629 9.06789 21.2638 9.8614V8.85434H19.6585ZM31.7699 8.6772C30.8648 8.6772 30.1865 9.21349 29.8347 9.72915C29.5071 9.06182 28.8155 8.67841 27.9831 8.67841C27.078 8.67841 26.4495 9.18073 26.1607 9.7607V8.85434H24.507V14.847H26.2226V11.7615C26.2226 10.6573 26.8026 10.1235 27.3437 10.1235C27.8339 10.1235 28.2841 10.4389 28.2841 11.2567V14.847H29.9961V11.7615C29.9961 10.6404 30.5627 10.1235 31.1281 10.1235C31.5819 10.1235 32.0623 10.4511 32.0623 11.2458V14.847H33.7756V10.7035C33.7756 9.35666 32.8692 8.6772 31.7736 8.6772M15.4871 8.85434H13.9353V8.24525C13.9353 7.45174 14.3878 7.22606 14.7773 7.22606C15.0442 7.2297 15.3051 7.29522 15.5417 7.41655L16.0707 6.20808C16.0707 6.20808 15.5344 5.85864 14.5601 5.85864C13.4657 5.85864 12.2196 6.47623 12.2196 8.41391V8.85434H9.62554V8.24525C9.62554 7.45174 10.0769 7.22606 10.4676 7.22606C10.7345 7.22606 10.9966 7.29158 11.232 7.41655L11.7598 6.20808C11.4443 6.02365 10.9384 5.85864 10.2504 5.85864C9.15598 5.85864 7.90989 6.47623 7.90989 8.41391V8.85434H6.91861V10.1757H7.91353V14.847H9.62432V10.1757H12.2233V14.847H13.9353V10.1757H15.4883V8.85313L15.4871 8.85434Z"
                                    fill="black"
                                />
                                <path d="M18.2206 8.85474H16.5098V14.8449H18.2206V8.85474Z" fill="black" />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M16.5723 7.83576H18.2479C19.2258 4.76241 22.543 2.06034 26.4863 2.06034C31.2838 2.06034 35.4286 5.71245 35.4286 11.3981C35.4432 12.5652 35.2829 13.728 34.9529 14.8476H36.5788L36.5958 14.7918C36.87 13.6828 37.0047 12.5447 36.9986 11.4029C36.9986 5.06332 32.3783 0.5 26.49 0.5C21.8648 0.5 17.7419 3.71046 16.5735 7.83819L16.5723 7.83576Z"
                                    fill="#4A4AF4"
                                />
                            </svg>
                            <span className="install-text">
                                {t.rich('footer_installation', {
                                    installNum: 12,
                                    totalMomey: FormatMoneyLocal(totalDiscount, locale),
                                })}
                            </span>
                        </div>
                    </div>
                    <Link
                        href={link_buy}
                        onClick={handleSubmit}
                        dataLayer={(() => {
                            let strs = '';
                            products?.map((p: any, k: number) => {
                                if (k !== 0 && !p?.remove && p.quantity > 0) {
                                    strs += '_';
                                }
                                if (!p?.remove && p.quantity > 0) {
                                    strs += `${p.title}_${p.quantity}`;
                                }
                            });
                            extend?.map((e: any) => {
                                if (e.quantity > 0) {
                                    strs += `_${e.title}_${e.quantity}`;
                                }
                            });
                            const both = extend[0]?.quantity > 0 && extend[1]?.quantity > 0;
                            return {
                                event: 'uaEvent',
                                event_name: 'calculator4_solar_generator',
                                step: t('header_step3'),
                                product_name: t(`header_step1${check1 === 2 ? '_b' : ''}`),
                                option_name: t(`step1_text${check1}`),
                                combo:
                                    (extend[0]?.quantity > 0 ? extend[0]?.title : '') + (both ? '_' : '') + (extend[1]?.quantity > 0 ? extend[1]?.title : ''),
                                add_on: strs,
                                price: totalDiscount,
                                button_name: t('footer_checkout'),
                            };
                        })()}
                        className="checkout"
                        target="_blank"
                    >
                        {t('footer_checkout')}
                    </Link>
                </div>
            )}
        </div>
    );
}
